import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-bgDefault text-white lg:px-6 px-5">
      <div className="container xl:mx-auto xl:max-w-screen-xl overflow-hidden">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-x-2  border-gray-700 lg:pb-8 pb-4">
          {/* Contact Info */}
          <div className="md:col-span-6 mt-2">
            <div>
            <div className='mb-6 '>
          <img src='/company_img/footer_logo.svg'></img>
        </div >
              <p className="lg:text-heading-5 font-medium font-dmsans">Email</p>
              <p className="text-body-sm tracking-[-6%] lg:text-body  mb-2  text-[#9E9E9E] font-roboto lg:font-normal">connect@techxplore.io</p>
              <p className="lg:text-heading-5 font-medium font-dmsans ">Phone</p>
              <p className="text-body-smlg:text-body  font-normal mb-2  text-[#9E9E9E] font-roboto">+91 - 9879129867</p>
               <p className="lg:text-heading-5 font-medium font-dmsansmb-2  ">Address</p>
              <p className="text-body-sm tracking-[-6%] lg:text-body  mb-2  text-[#9E9E9E] font-roboto lg:font-normal lg:pr-56 pr-6">A-1103, Infinity Tower, Corporate Road, Near Ramada Hotel,
                Satellite, Ahmedabad, Gujarat 380015</p>
            </div>
          </div>

          {/* Services + More Links + Social */}
          <div className="md:col-span-6 grid grid-cols-2 sm:grid-cols-3 lg:gap-x-16 gap-x-4 gap-y-4 mt-10 lg:mt-0">
            {/* Services */}
            <div>
              <p className="lg:text-heading-5 font-medium font-dmsans mb-2">Services</p>
              <ul className="text-[#9E9E9E] space-y-3 lg:text-body text-body-sm font-roboto">
                <li><Link to="/services">Enterprise Application</Link></li>
                <li><Link to="/services">AI/ML</Link></li>
                <li><Link to="/services">Android Development</Link></li>
                <li><Link to="/services">iOS Development</Link></li>
                <li><Link to="/services">Cloud Computing</Link></li>
                <li><Link to="/services">UI/UX</Link></li>
              </ul>
            </div>

            {/* More Links */}
            <div>
              <p className="lg:text-heading-5 font-medium font-dmsans mb-2">More Links</p>
              <ul className="text-[#9E9E9E] space-y-3 lg:text-body text-body-sm font-roboto">
                <li><Link to="/case-studies">Case Studies</Link></li>
                <li><Link to="/about-us">About Us</Link></li>
                {/* <li><Link to="/career">Career</Link></li> */}
                <li><Link to="/contact">Contact Us</Link></li>
              </ul>
            </div>

            {/* Social Media */}
            <div>
              <p className="lg:text-heading-5 font-medium font-dmsans mb-2">Social Media</p>
              <div className="flex space-x-4 text-gray-300">
                <a href="mailto:connect@techxplore.io"><Mail size={18} /></a>
                <a href="https://www.linkedin.com/company/techxploreio" target='_blank' rel="noopener noreferrer"><Linkedin size={18} /></a>
              </div>
            </div>
          </div>
        </div>

        {/* <div className='mt-10 '>
          <img src='/company_img/Techxplore_lg.svg'></img>
        </div> */}

        {/* Bottom Bar */}
        <div className="mt-8 pt-4 text-sm flex flex-col md:flex-row lg:justify-between text-[#9E9E9E] text-center mb-4">
          <p>© 2025 Techxplore. All rights reserved.</p>
          <div className="space-x-4 mt-2 md:mt-0">
            <Link to="#">Privacy Policy</Link>
            <Link to="#">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
